// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cm-table-guide {
  position: absolute;
  inset: 0;
  z-index: 4;
  pointer-events: none;
}

.cm-table-guide__svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  overflow: visible;
}

.cm-table-guide__band,
.cm-table-guide__surface,
.cm-table-guide__center,
.cm-table-guide__net,
.cm-table-guide__mesh,
.cm-table-guide__cord,
.cm-table-guide__tick {
  vector-effect: non-scaling-stroke;
  stroke-linejoin: round;
  stroke-linecap: round;
}

.cm-table-guide__band {
  fill: none;
  stroke: rgba(255, 255, 255, 0.88);
  stroke-width: 2;
}

.cm-table-guide__surface {
  fill: rgba(125, 211, 252, 0.14);
  stroke: none;
}

.cm-table-guide__center {
  fill: none;
  stroke: rgba(255, 255, 255, 0.78);
  stroke-width: 1.25;
}

.cm-table-guide__net {
  fill: rgba(255, 255, 255, 0.2);
  stroke: rgba(255, 255, 255, 0.55);
  stroke-width: 1;
}

.cm-table-guide__mesh {
  fill: none;
  stroke: rgba(255, 255, 255, 0.45);
  stroke-width: 0.8;
}

.cm-table-guide__cord {
  fill: none;
  stroke: rgba(255, 255, 255, 0.9);
  stroke-width: 1.6;
}

.cm-table-guide__tick {
  fill: none;
  stroke: #7dd3fc;
  stroke-width: 2.4;
}

.cm-table-guide__hint {
  position: absolute;
  top: calc(2.35rem + env(safe-area-inset-top, 0px));
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: calc(100% - 1.5rem);
  margin: 0;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  background: rgba(2, 6, 23, 0.45);
  text-align: center;
  color: #f8fafc;
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.85);
  pointer-events: none;
}

.cm-table-guide__score {
  position: absolute;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.28rem;
  border: 1.5px dashed rgba(125, 211, 252, 0.92);
  border-radius: 10px;
  background: rgba(14, 165, 233, 0.12);
  color: #e0f2fe;
  box-shadow: 0 0 0 1px rgba(2, 6, 23, 0.35);
  pointer-events: none;
}

.cm-table-guide__score span {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}

.cm-table-guide__toggle {
  pointer-events: auto;
  position: absolute;
  top: calc(0.5rem + env(safe-area-inset-top, 0px));
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 0.32rem;
  height: 1.7rem;
  padding: 0 0.6rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(2, 6, 23, 0.62);
  color: #e2e8f0;
  font: inherit;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.02em;
  cursor: pointer;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.cm-table-guide__toggle.is-on {
  border-color: rgba(125, 211, 252, 0.75);
  color: #e0f2fe;
  background: rgba(8, 47, 73, 0.72);
}

.cm-table-guide__toggle:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

.cm-table-guide--settings .cm-table-guide__toggle {
  top: calc(78px + env(safe-area-inset-top, 0px));
  left: 16px;
  transform: none;
}

.cm-table-guide--settings .cm-table-guide__hint {
  top: calc(118px + env(safe-area-inset-top, 0px));
}

@media (orientation: landscape) {
  .cm-table-guide--settings .cm-table-guide__toggle {
    top: calc(48px + env(safe-area-inset-top, 0px));
  }

  .cm-table-guide--settings .cm-table-guide__hint {
    top: calc(86px + env(safe-area-inset-top, 0px));
  }
}

@media (prefers-reduced-motion: reduce) {
  .cm-table-guide__toggle {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/championship/TableCameraGuide.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,iCAAiC;EACjC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,8CAA8C;EAC9C,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iDAAiD;EACjD,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,+CAA+C;EACjD;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".cm-table-guide {\n  position: absolute;\n  inset: 0;\n  z-index: 4;\n  pointer-events: none;\n}\n\n.cm-table-guide__svg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  overflow: visible;\n}\n\n.cm-table-guide__band,\n.cm-table-guide__surface,\n.cm-table-guide__center,\n.cm-table-guide__net,\n.cm-table-guide__mesh,\n.cm-table-guide__cord,\n.cm-table-guide__tick {\n  vector-effect: non-scaling-stroke;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n}\n\n.cm-table-guide__band {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.88);\n  stroke-width: 2;\n}\n\n.cm-table-guide__surface {\n  fill: rgba(125, 211, 252, 0.14);\n  stroke: none;\n}\n\n.cm-table-guide__center {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.78);\n  stroke-width: 1.25;\n}\n\n.cm-table-guide__net {\n  fill: rgba(255, 255, 255, 0.2);\n  stroke: rgba(255, 255, 255, 0.55);\n  stroke-width: 1;\n}\n\n.cm-table-guide__mesh {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.45);\n  stroke-width: 0.8;\n}\n\n.cm-table-guide__cord {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.9);\n  stroke-width: 1.6;\n}\n\n.cm-table-guide__tick {\n  fill: none;\n  stroke: #7dd3fc;\n  stroke-width: 2.4;\n}\n\n.cm-table-guide__hint {\n  position: absolute;\n  top: calc(2.35rem + env(safe-area-inset-top, 0px));\n  left: 50%;\n  transform: translateX(-50%);\n  width: max-content;\n  max-width: calc(100% - 1.5rem);\n  margin: 0;\n  padding: 0.15rem 0.45rem;\n  border-radius: 999px;\n  background: rgba(2, 6, 23, 0.45);\n  text-align: center;\n  color: #f8fafc;\n  font-size: 0.68rem;\n  font-weight: 700;\n  line-height: 1.3;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.85);\n  pointer-events: none;\n}\n\n.cm-table-guide__score {\n  position: absolute;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.28rem;\n  border: 1.5px dashed rgba(125, 211, 252, 0.92);\n  border-radius: 10px;\n  background: rgba(14, 165, 233, 0.12);\n  color: #e0f2fe;\n  box-shadow: 0 0 0 1px rgba(2, 6, 23, 0.35);\n  pointer-events: none;\n}\n\n.cm-table-guide__score span {\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);\n}\n\n.cm-table-guide__toggle {\n  pointer-events: auto;\n  position: absolute;\n  top: calc(0.5rem + env(safe-area-inset-top, 0px));\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.32rem;\n  height: 1.7rem;\n  padding: 0 0.6rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(2, 6, 23, 0.62);\n  color: #e2e8f0;\n  font: inherit;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.cm-table-guide__toggle.is-on {\n  border-color: rgba(125, 211, 252, 0.75);\n  color: #e0f2fe;\n  background: rgba(8, 47, 73, 0.72);\n}\n\n.cm-table-guide__toggle:focus-visible {\n  outline: 2px solid #38bdf8;\n  outline-offset: 2px;\n}\n\n.cm-table-guide--settings .cm-table-guide__toggle {\n  top: calc(78px + env(safe-area-inset-top, 0px));\n  left: 16px;\n  transform: none;\n}\n\n.cm-table-guide--settings .cm-table-guide__hint {\n  top: calc(118px + env(safe-area-inset-top, 0px));\n}\n\n@media (orientation: landscape) {\n  .cm-table-guide--settings .cm-table-guide__toggle {\n    top: calc(48px + env(safe-area-inset-top, 0px));\n  }\n\n  .cm-table-guide--settings .cm-table-guide__hint {\n    top: calc(86px + env(safe-area-inset-top, 0px));\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cm-table-guide__toggle {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
